import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from 'antd';
import Home from "../Home";

const StyledButton = styled(Button)`
  height: 50px;
  width: 870px;
  border-radius: 4px;
  background: #27d974;
  color: white;
  border-width: 0;
  text-transform: uppercase;
  font-size: 15px;
  padding: 15px 36px;
  margin-bottom: 15px;
  box-shadow: 0 0 20px #ccc;
  &:hover,
  &:focus {
    background: #028a3d;
    color: white;
  }
`;
const StyledLoadSummary = styled.div`
  width: 870px;
  height: 14px;
  font-weight: 700;
  color: #0093ee;
  line-height: 14px;
  text-align: center;
`;

/**
 * @component
 * @category Form Page
 * @name SearchBook
 * @description It's the Search and book button on Form.
 * <br> <br>
 * **Example**
 * ```js
 *  <SearchBook nextBtnClick={1}/>
 * ```
 */
class SearchBook extends Component {

  render() {
    const { loadSummaryText, nextBtnClick, submitForm } = this.props;

    return (
      <div>
        <StyledButton
          onClick={()=>{
              submitForm(nextBtnClick);

          }}
        >
          SEARCH &amp; BOOK
        </StyledButton>
        <StyledLoadSummary>
          <span>{loadSummaryText}</span>
        </StyledLoadSummary>
      </div>
    );
  }
}

SearchBook.propTypes = {
  /**
   * summary text under search and book button
   */
  loadSummaryText: PropTypes.string,
  /**
   * How many times next-step button is clicked
   */
  nextBtnClick: PropTypes.number,
};

const mapStateToProps = (state) => {
  return {
    // loading: state.route.loading,
    // showForm: state.form.showForm,
    loadSummaryText: state.form.loadSummaryText,
    // showReCaptcha: state.code_config.showReCaptcha,
  };
};

export default connect(mapStateToProps, actions)(SearchBook);
